import { Paging } from "../common/state-models/paging";
import { variantCodeValues } from "../production-price-list/state-models/production-price-condition";
import { PriceListForm, PriceType} from "./state-models/price-list-form";

export interface PriceListFormState {
    priceListForm: PriceListForm[] | null;
    priceTypes: PriceType[];
    variantCombination: variantCodeValues[];
    variantCombinationPaging: Paging;
    variantCombinationSortExpression: string;
}
